import React from 'react';
export function MoneyChange() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11V9C2 5.5 4 4 7 4H17C20 4 22 5.5 22 9V15C22 18.5 20 20 17 20H12M18.5 9.5V14.5M2 15.5H7.34003C7.98003 15.5 8.5 16.02 8.5 16.66V17.94M2 15.5L3.21997 14.28M2 15.5L3.21997 16.72M8.5 20.78H3.15997C2.51997 20.78 2 20.26 2 19.62V18.34M7.28125 22.0003L8.50122 20.7803L7.28125 19.5603M14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}